module.exports = __webpack_public_path__ + "img/banner-1.32dbbe6e.png";